import React from "react";
import Pagination from "react-bootstrap/Pagination";
import "./Page.css";

const Page = ({ activePageNum, pageNumbers, paginate }) => {
    const [firstPageNumber, setFirstPageNumber] = React.useState(1);

    let items = [];
    let lastPageNumber;

    if (firstPageNumber + 9 > pageNumbers.length) {
        lastPageNumber = pageNumbers.length;
    } else {
        lastPageNumber = firstPageNumber + 9;
    }

    for (let number = firstPageNumber; number <= lastPageNumber; number += 1) {
        items.push(
            <Pagination.Item key={number} active={number === activePageNum} onClick={() => paginate(number)}>
                {number}
            </Pagination.Item>
        );
    }

    const handleFirstPageClick = () => {
        paginate(1);
        setFirstPageNumber(1);
    };

    const handleLastPageClick = () => {
        paginate(pageNumbers.length);
        if (pageNumbers.length - 9 < 0) {
            setFirstPageNumber(1);
        } else {
            setFirstPageNumber(pageNumbers.length - 9);
        }
    };

    const handlePrevPageClick = () => {
        let activePage = activePageNum;
        let firstPageNum = firstPageNumber;

        if (activePage - 10 >= 1) {
            paginate(activePage - 10);
            if (firstPageNumber - 10 <= 1) {
                setFirstPageNumber(1);
            } else {
                setFirstPageNumber(firstPageNum - 10);
            }
        } else {
            setFirstPageNumber(1);
        }
    };

    const handleNextPageClick = () => {
        let activePage = activePageNum;
        let firstPageNum = firstPageNumber;

        if (activePage > pageNumbers.length - 10) {
            setFirstPageNumber(pageNumbers.length - 9);
        } else {
            paginate(activePage + 10);
            setFirstPageNumber(firstPageNum + 10);
        }
    };

    return pageNumbers.length > 10 ? (
        <Pagination className="pagination">
            <Pagination.First onClick={handleFirstPageClick} />
            <Pagination.Prev onClick={handlePrevPageClick} />
            {items}
            <Pagination.Next onClick={handleNextPageClick} />
            <Pagination.Last onClick={handleLastPageClick} />
        </Pagination>
    ) : (
        <Pagination>{items}</Pagination>
    );
};

export default Page;
